import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-start-survey-without-data',
  templateUrl: './start-survey-without-data.component.html',
  styleUrls: ['./start-survey-without-data.component.scss']
})
export class StartSurveyWithoutDataComponent implements OnInit, IDialogView {
  data: DialogModel;

  constructor() { }

  ngOnInit() {
  }

  onOkClicked(): boolean {
    return true;
  }

}
